/** Orders projects by name, case-insensitively, as the project pickers list them. */
export function compareProjectNames(a: { name: string }, b: { name: string }): number {
  return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
}
